<template>
    <div class="c-app flex-row align-items-center">
        <CContainer style="display: flex; justify-content: center" class="p-0">
            <div class="container-box center">
                <div class="text-left">
                    <div class="card-custom-web">
                        <CRow class="p-3">
                            <CCol sm="12">
                                <h5>Find Available Tutor</h5>
    
    
                                <CProgress :value="progress" :max="100" show-percentage color="info" :striped="striped" class="mb-3" />
    
                                <h5>Send Notification</h5>
    
    
                                <CProgress :value="progress2" :max="100" show-percentage color="info" :striped="striped" class="mb-3" />
    
    
                                <h5>Send Email</h5>
    
    
                                <CProgress :value="progress3" :max="100" show-percentage color="info" :striped="striped" class="mb-3" />
    
                            </CCol>
                        </CRow>
                        <div class="bottom-center text-center">
                            <CButton style="
                          position: fixed;
                          bottom: 100px;
                          left: 0px;
                          right: 0px;
                          text-align: center;
                          margin: 0 auto;
                          " color="info" class="btn-select-blue mt-5" @click="InsertFindTutor">
                                {{ buttonLabel }}
                            </CButton>
                        </div>
                    </div>
    
    
                </div>
            </div>
            <MainlayoutBottom></MainlayoutBottom>
        </CContainer>
    
    
    
        <div style="clear: both"></div>
        <div class="header-top">Summary</div>
        <div class="header-left">
            <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
        </div>
        <div style="clear: both"></div>
    </div>
</template>
  
<script>
import Vue from "vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";
Vue.use(VuejsDialog);
export default {
    components: {
        MainlayoutBottom,
    },
    data: function() {
        return {
            user: {},
            subject: [],
            student: {},
            FilterSubject: [],
            StudentId: this.$route.query.studentId,
            GradeId: this.$route.query.gradeId,
            SubjectId: this.$route.query.subjectId,
            Subject: this.$route.query.subjectName,
            LanguageId: this.$route.query.languageId,
            Language: this.$route.query.language,
            DayId: this.$route.query.dayId,
            Day: this.$route.query.day,
            HourId: this.$route.query.hourId,
            Hour: this.$route.query.hour,
            DurationId: this.$route.query.durationId,
            Duration: this.$route.query.duration,
            SubmittedForm: false,
            SearchQuery: "",
            SelectedSubject: "",

            studentProfileAuthorize: "",

            wallet: {},
            price: {},
            language: [],
            popupTopup: false,
            // remaining: this.remain,
            buttonLabel: 'Find Tutor',
            remain: 0,

            progress: 0,
            progress2: 0,
            progress3: 0,
            striped: true,
        };
    },
    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();
        } else {
            this.GoToLogin();
        }
    },
    methods: {
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetailWebs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        //this.GetSubject();
                        this.GetStudent(this.$route.query.studentId);
                        this.GetWalletAmount(this.user.id);
                        this.GetPriceRate(this.$route.query.gradeId, this.$route.query.durationId);
                        this.GetLanguage();
                    }
                });
        },

        GetStudent() {
            this.$API
                .get(this.$StudentProfile + "?studentId=" + this.$route.query.studentId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.student = response.data;
                        //this.studentid = this.student.id;
                        console.log("student", this.student);
                    }
                });
        },

        GetWalletAmount() {
            this.$API
                .get(this.$EwalletAmount + "?id=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.wallet = response.data;
                        this.GetPriceRate(this.wallet.currentAmount);
                    }
                });
        },

        GetPriceRate(currentAmount) {
            this.$API
                .get(this.$GetPrice +
                    "?gradeId=" +
                    this.$route.query.gradeId +
                    "&durationId=" +
                    this.$route.query.durationId +
                    "&isGroup=false", {
                        withCredentials: true,
                    })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.price = response.data;

                        let available = currentAmount;
                        let charged = this.price.Rate;
                        let remaining = available - charged;
                        this.remain = remaining;
                        console.log("REMAIN", this.remain);

                        // if(this.remain = 'NaN')
                        // {
                        //  this.$router.go(0);
                        //  }

                    }
                });
        },

        //   GetAuthorizeProfile() {
        //   this.$API
        //     .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
        //       withCredentials: true,
        //     })
        //     .then((response) => {
        //       if (response.status == 200 && response.data != null) {
        //         this.studentProfileAuthorize = response.data;
        //         this.photoURL =
        //           "https://pickiddo.com" + this.studentProfileAuthorize;
        //       }
        //     });
        // },
        // GetSubject() {
        //   this.$API
        //     .get(this.$SubjectListAuthorize, {
        //       withCredentials: true,
        //     })
        //     .then((response) => {
        //       if (response.status == 200 && response.data != null) {
        //         this.subject = response.data;
        //         this.FilterSubject = this.subject;
        //       }
        //     });
        // },

        GoToTopup() {
            this.$router.push("/ParentProfile/Topup");
        },

        GoBack() {
            this.$router.back();
        },

        GetLanguage() {
            this.$API
                .get(this.$Languages, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.language = response.data;
                    }
                });
        },

        InsertFindTutor() {
            if (this.wallet.currentAmount > this.price.Rate && this.wallet.currentAmount >= 0) {

                const hasTeacherId = this.$route.query.hasOwnProperty('teacherId');

              
                    this.buttonLabel = 'Processing';
                    const formData = new FormData();

                    let langJson = JSON.stringify([{ "LanguageId": this.LanguageId }])

                    formData.append("studentId", this.StudentId);
                    formData.append("teachingGradeId", this.GradeId);
                    formData.append("teachingSubjectId", this.SubjectId);
                    formData.append("language", langJson);
                    formData.append("dayId", this.DayId);
                    formData.append("timeId", this.HourId);
                    formData.append("durationId", this.DurationId);
                    formData.append("isGroup", false);

                    const config = {
          onUploadProgress: progressEvent => {
            this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
          withCredentials: true,
        };

        return this.$API.post(this.$StudentFilterSubjectSeparateP1, formData, config)
          .then((response) => {
            if (response.status === 200 && response.data !== null) {
              //this.$dialog.alert("Request Sent.");
              this.findTutorID = response.data;
              this.InsertFindTutorP2(this.findTutorID);
              this.InsertFindTutorP3(this.findTutorID);
               this.GoToAllSet();
            
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
            }
          });
                

            } else {
                this.popupTopup = true;
            }
        },

        InsertFindTutorP2(findTutorID) {
            if (this.wallet.currentAmount > this.price.Rate && this.wallet.currentAmount >= 0) {

              
                    this.buttonLabel = 'Processing';
                    const formData = new FormData();

                    let langJson = JSON.stringify([{ "LanguageId": this.LanguageId }])

                    formData.append("findTutorId", findTutorID);
                    formData.append("teachingGradeId", this.GradeId);
                    formData.append("teachingSubjectId", this.SubjectId);
                    formData.append("language", langJson);
                    formData.append("dayId", this.DayId);
                    formData.append("timeId", this.HourId);
                    formData.append("durationId", this.DurationId);
                    formData.append("isGroup", false);

                    const config = {
          onUploadProgress: progressEvent => {
            this.progress2 = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
          withCredentials: true,
        };

        return this.$API.post(this.$StudentFilterSubjectSeparateP2, formData, config)
          .then((response) => {
            if (response.status === 200 && response.data !== null) {
            //  this.$dialog.alert("Request Sent.");
             // this.GoToAllSet();
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
            }
          });
                

            } else {
                this.popupTopup = true;
            }
        },

        InsertFindTutorP3(findTutorID) {
            if (this.wallet.currentAmount > this.price.Rate && this.wallet.currentAmount >= 0) {

              
                    this.buttonLabel = 'Processing';
                    const formData = new FormData();

                    let langJson = JSON.stringify([{ "LanguageId": this.LanguageId }])

                    formData.append("findTutorId", findTutorID);
                    formData.append("teachingGradeId", this.GradeId);
                    formData.append("teachingSubjectId", this.SubjectId);
                    formData.append("language", langJson);
                    formData.append("dayId", this.DayId);
                    formData.append("timeId", this.HourId);
                    formData.append("durationId", this.DurationId);
                    formData.append("isGroup", false);

                    const config = {
          onUploadProgress: progressEvent => {
            this.progress3 = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
          withCredentials: true,
        };

        return this.$API.post(this.$StudentFilterSubjectSeparateP3, formData, config)
          .then((response) => {
            if (response.status === 200 && response.data !== null) {
             // this.$dialog.alert("Request Sent.");
             // this.findTutorID = response.data;
              //this.SubmitFindTutorNotification(this.findTutorID);
             // this.GoToAllSet();
             this.GoToAllSet();
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
            }
          });
                

            } else {
                this.popupTopup = true;
            }
        },

        async RefreshModal() {
            this.popupTopup = false;
        },

        GoToAllSet() {
            this.$router.push("FTAllSet");
        },
    },
};
</script>
  
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
input[type="text"] {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
}

input[type="checkbox"] {
    opacity: 0;
}

input ::placeholder {
    color: #e0e0e0;
}

::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
}

.c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

.custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
}

body {
    font-family: "Montserrat", sans-serif;
}

.card-custom-web {
    max-width: 700px;
    left: 0px;
    margin-top: 129px;
    height: 100vh;
    /* Off white */
    background: #f9f9f9;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
    border-radius: 32px 0px 0px 0px;
    color: #000;
}

.label-blue {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 0px;
}
</style>
  